import React, { useEffect, useState } from 'react';
import UseFetchPost from './components/shared/useFetchPost';
import { devOrProd, useTailwindMediaQuery } from './components/shared/utils';
import {
  sevenHomepage,
  brandFocusFeed,
  brandStoryFeed
} from './components/shared/jsonData';
import './styles/app.scss';

// HOMEPAGE COMPONENTS
import Hero from './components/Hero';
import BrandList from './components/BrandList';
import NewArrivals from './components/NewArrivals';
import CreativeFeature from './components/CreativeFeature';
import Banner from './components/Banner';
import CreativeFeatureSlider from './components/CreativeFeatureSlider';
import HeroWithText from './components/HeroWithText';
import RaffleSlider from './components/RaffleSlider';
import Editorial from './components/Editorial';
import Storyly from './components/Storyly';
import BrandFocus from './components/BrandFocus';
import BrandStory from './components/BrandStory';
import TitleAndText from './components/TitleAndText';
import HeroVideo from './components/HeroVideo/HeroVideo';
import HeroVideoBackground from './components/HeroVideoBackground';
import CreativeFeatureVideo from './components/CreativeFeature/Video';
import CategoriesBrands from './components/BlackFriday/categories-brands.jsx';
//import PromoEventCutoff from './components/BannerTimer/index.js';

const App = () => {
  const [componentData, setComponentData] = useState({});
  const isMobile = useTailwindMediaQuery('md');

  // GET DATA FROM NQ
  const getData = UseFetchPost(
    sevenHomepage.endPointUrl,
    sevenHomepage.endPointPrams
  );

  // API DATA
  useEffect(() => {
    if (getData && getData.data) {
      let content = getData.data.content.content;
      let tempComponentData = {
        hero3: content[0].data.block_reference,
        hero: content[1].data.block_reference,
        titleAndText: content[2].data,
        creativeFeature: content[3].data.block_reference,
        editorialFeature: content[4].data.block_reference,
        editorialCards: content[5].data.block_reference,
        brandFocus: content[6].data.block_reference,
        brandStory: content[7].data.block_reference,
        editorialFeature2: content[8].data.block_reference,
        hero2: content[9].data.block_reference,
        heroVideo: content[10].data.seven_video_hero_container,
        heroWithText: content[11].data.seven_black_friday_container,
        creativeFeatureVideo: content[12].data,
        creativeFeature2: content[13].data.block_reference,
        creativeFeatureSlider: content[14].data,
        creativeFeatureSlider2: content[15].data,
        bfCategories: content[16].data,
        bfBrands: content[17].data
      };
      setComponentData(tempComponentData);
    }
  }, [getData]);

  return (
    <section className="font-sans text-base font-base tracking-widest">
      {/* Fix to remove extra spacing on test site */}
      {devOrProd === 'dev' && (
        <style>
          {'div.main:not(.localhost) {padding-top: 11px !important;}'}
        </style>
      )}

      {/* END OF SEASON SALE COMPONENTS */}
      <div className="flex flex-col gap-14 md:gap-28 pb-20 md:pb-32 mb-24 lg:mb-32 bg-blackFriday1">
        <Banner
          cta={'UP TO 50% OFF'}
          bfpDescription={'END OF SEASON SALE'}
          blackFridayPreview={true}
          blackFriday24={true}
          buttonLink={'sale/'}
          buttonLinkText={'Shop Now'}
          gaBlockTitle={'End of Season Sale Banner Button'}
          gaBlockName={'End of Season Sale'}
          gaBlockId={'end-of-season-sale-banner-button'}
          endSale25={true}
          endSale25BGVid={
            isMobile
              ? 'https://fa-ecom.s3.eu-west-2.amazonaws.com/images/sevenstore/sale/SS_EOS_DEKSTOP_1920x1920a.webm'
              : 'https://fa-ecom.s3.eu-west-2.amazonaws.com/images/sevenstore/sale/SS_EOS_DEKSTOP_1920x1920a.webm'
          }
          endSale25BGVidType={'video/webm'}
        />

        <CategoriesBrands
          data={componentData.bfCategories}
          gaBlockName={'End of Season Sale Categories'}
          categoryBrandOptions={{
            classes: 'categories-1'
          }}
          showCategoryBrand={true}
        />

        <CategoriesBrands
          data={componentData.bfBrands}
          gaBlockName={'End of Season Sale Brands'}
          categoryBrandOptions={{
            classes: 'brands-1'
          }}
          showCategoryBrand={true}
        />

        <NewArrivals
          gaBlockName={'End of Season Sale Carousel'}
          gaBlockNameClothing={'End of Season Sale Carousel Clothing'}
          gaBlockNameFootwear={'End of Season Sale Carousel Footwear'}
          gaBlockNameAccessories={'End of Season Sale Carousel Accessories'}
          newArrivalsHeading={'End of Season Sale Top Selects'}
          newArrivalsOptions={{
            classes: 'black-friday-top-selects-1 !my-0'
          }}
          blackFriday={true}
          blackFridayBadge={'End of Season Sale'}
          isSeventhImage={false}
          newArrivalsButtonLinkAll={'/sale/'}
          newArrivalsButtonLinkClothing={'/sale/?category_default_codes=am'}
          newArrivalsButtonLinkFootwear={'/sale/?category_default_codes=fm'}
          newArrivalsButtonLinkAcc={'/sale/?category_default_codes=cm'}
        />
      </div>

      {/* EDITORIAL - FEATURE LARGE 1 */}
      <Editorial
        data={componentData.editorialFeature}
        gaBlockName={'Feature Large'}
        featureLayout={true}
        showFeatureLayoutEditorial={true}
        topMargin={false}
        featureLayoutOptions={{
          classes: 'editorial-large-1 lg:!mt-44'
        }}
      />

      {/* BRAND LIST */}
      <BrandList
        gaBlockName={'Brand'}
        blackFriday={true}
        brandListOptions={{
          classes: 'brand-list-1'
        }}
      />

      {/* BRAND STORY */}
      <BrandStory
        brandStoryData={componentData.brandStory}
        brandStoryFeed={UseFetchPost(
          brandStoryFeed.endPointUrl,
          brandStoryFeed.endPointPrams
        )}
        gaBlockName={'Product Focus'}
        showBrandStory={true}
        brandStoryOptions={{
          classes: 'brand-story lg:!my-32'
        }}
      />

      {/* CREATIVE FEATURE - SLIDER 1 - RIGHT */}
      <CreativeFeatureSlider
        data={componentData.creativeFeatureSlider}
        gaBlockName={'Creative Feature Slider'}
        creativeFeatureSliderOptions={{
          classes: 'creative-feature-slider md:!my-44'
        }}
        showCreativeFeatureSlider={true}
        sliderRight={true}
        singleHero={false}
      />

      {/* CREATIVE FEATURE - 1 */}
      <CreativeFeature
        data={componentData.creativeFeature}
        gaBlockName={'Brand Strip'}
        creativeFeatureOptions={{
          classes: 'creative-feature-1 lg:!my-32'
        }}
        showCreativeFeature={true}
      />

      {/* BRAND FOCUS */}
      <BrandFocus
        brandFocusData={componentData.brandFocus}
        brandFocusFeed={UseFetchPost(
          brandFocusFeed.endPointUrl,
          brandFocusFeed.endPointPrams
        )}
        heroGaBlockName={'Category Focus'}
        carouselGaBlockName={'Category Carousel'}
        showBrandFocus={true}
        brandFocusOptions={{
          classes: 'brand-focus lg:!my-32'
        }}
      />

      {/* EDITORIAL - FEATURE LARGE 2 */}
      <Editorial
        data={componentData.editorialFeature2}
        gaBlockName={'Feature Large'}
        featureLayout={true}
        showFeatureLayoutEditorial={true}
        featureLayoutOptions={{
          classes: 'lg:my-36'
        }}
      />

      {/* EDITORIAL - FEATURE SMALL */}
      <Editorial
        data={componentData.editorialCards}
        gaBlockName={'Feature Small'}
        showSmallLayout={true}
        smallLayoutOptions={{
          classes: 'editorial-small-1 lg:!my-36'
        }}
      />

      {/* BANNER */}
      <Banner
        cta={'stay in the know.'}
        salePromo={true}
        description={
          //'10% OFF IN THE APP. Get exclusive offers when you sign up for our newsletter and download our app.'
          <div className="flex flex-col gap-4">
            <p className="font-bold">
              15% off your first order when you sign up to our newsletter.
            </p>
            <p>
              Get more exclusive offers, LAUNCHES and product releases when you
              sign up for our newsletter and download our app.
            </p>
          </div>
        }
        input={true}
        inputPlaceholder={'SUBSCRIBE.'}
        appBannerOptions={{
          classes: 'app-banner-1 lg:mt-32'
        }}
      />

      {/* ---------- EVERYTHING BELOW IS FOR STAGING TESTING ---------- */}
      {devOrProd === 'dev' && (
        <>
          <div className="flex flex-col justify-center items-center py-20 md:py-32 mb-24 lg:mb-32 bg-blackFriday1">
            <h2 className="text-black font-extrabold text-2xl md:text-3xl lg:text-4xl text-center">
              See below for all additional components - currently not in use
            </h2>
          </div>

          {/* NEW ARRIVALS */}
          <NewArrivals
            gaBlockName={'New Arrivals Carousel'}
            gaBlockNameClothing={'New Arrivals Clothing'}
            gaBlockNameFootwear={'New Arrivals Footwear'}
            gaBlockNameAccessories={'New Arrivals Accessories'}
            newArrivalsHeading={'New Arrivals'}
            newArrivalsOptions={{
              classes: 'new-arrivals-1 lg:!my-24'
            }}
            isSeventhImage={false}
            newArrivalsButtonLinkAll={'/latest/'}
            newArrivalsButtonLinkClothing={'/latest/clothing/'}
            newArrivalsButtonLinkFootwear={'/latest/footwear/'}
            newArrivalsButtonLinkAcc={'/latest/accessories/'}
          />

          {/* BANNER - 20% Discount - App Exclusive */}
          <Banner
            cta={'App Exclusive 20% Off'}
            description={'Use Code: APP20 at checkout'}
            app20={true}
            buttonLinkText={'Download Now'}
            gaBlockTitle={'App Exclusive 20% Off Banner Button'}
            gaBlockName={'App Exclusive 20% Off'}
            gaBlockId={'app-exclusive-20-banner-button'}
          />

          {/* HERO - HERO 1 */}
          <Hero
            data={componentData.hero}
            gaBlockName={'Hero Carousel'}
            topMargin={false}
            singleHero={true}
            autoplay={false}
            showHero={true}
            salePromo={false}
            heroOptions={{
              classes: 'hero-1'
            }}
          />

          {/* HERO - HERO 2 */}
          <Hero
            data={componentData.hero2}
            gaBlockName={'Hero Carousel 2'}
            topMargin={false}
            singleHero={true}
            autoplay={false}
            showHero={true}
            salePromo={true}
            heroOptions={{
              classes: 'hero-2'
            }}
          />

          {/* HERO - HERO 3 */}
          <Hero
            data={componentData.hero3}
            gaBlockName={'Hero Carousel 3'}
            topMargin={false}
            singleHero={false}
            autoplay={false}
            showHero={true}
            heroOptions={{
              classes: 'hero-3'
            }}
          />

          {/* HERO - VIDEO BACKGROUND */}
          <HeroVideoBackground
            data={componentData.heroVideo}
            gaBlockName={'Hero Video'}
            topMargin={false}
            isLoop={true}
            isAutoPlay={true}
            isControls={false}
            isMuted={true}
            showHeroVideoBackground={true}
            salePromo={true}
            heroVideoOptions={{
              classes: 'hero-video'
            }}
            heroVideoAspect={{
              classes: '!aspect-[1/1] md:!aspect-[3/1]'
            }}
            clickOnBanner={true}
          />

          {/* HERO - WITH TEXT OVERLAY */}
          <HeroWithText
            data={componentData.heroWithText}
            gaBlockName={'Hero Carousel'}
            topMargin={false}
            singleHero={true}
            showHeroWithText={true}
            thinStrip={true}
            extraThinStrip={false}
            heroWithTextOptions={{
              classes: 'hero-with-text mb-16 lg:mb-32'
            }}
          />

          <div className="flex flex-col justify-center items-center py-20 lg:mb-32 bg-blackFriday1">
            <h2 className="text-black font-extrabold text-2xl md:text-3xl lg:text-4xl text-center">
              Click 'View More' on the below component for video popup
            </h2>
          </div>
          {/* HERO - VIDEO POPUP */}
          <HeroVideo
            data={componentData.heroVideo}
            gaBlockName={'Hero Video - Modal'}
            topMargin={false}
            showHeroVideo={true}
          />

          {/* RAFFLE SWIPER */}
          <RaffleSlider />

          {/* CREATIVE FEATURE - 2 */}
          <CreativeFeature
            data={componentData.creativeFeature2}
            gaBlockName={'Brand Strip'}
            creativeFeatureOptions={{
              classes: 'creative-feature-2'
            }}
            showCreativeFeature={true}
          />

          {/* CREATIVE FEATURE - VIDEO */}
          <CreativeFeatureVideo
            data={componentData.creativeFeatureVideo}
            gaBlockName={'Brand Strip'}
            creativeFeatureVideoOptions={{
              classes: 'mt-12 lg:mt-32'
            }}
            showCreativeFeatureVideo={devOrProd === 'dev' ? true : false}
          />

          {/* CREATIVE FEATURE - SLIDER 2 - LEFT */}
          <CreativeFeatureSlider
            data={componentData.creativeFeatureSlider2}
            gaBlockName={'Creative Feature Slider'}
            creativeFeatureSliderOptions={{
              classes: 'creative-feature-slider-2'
            }}
            showCreativeFeatureSlider={true}
            sliderRight={false}
            singleHero={false}
          />

          {/* STORYLY */}
          <Storyly
            storylyToken="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhY2NfaWQiOjU3NzcsImFwcF9pZCI6MTE0NTUsImluc19pZCI6MTIyMzR9.b-keMHACgsvKeHCC2qumUjcZop550-rWBcKjeM-J42A"
            storylyHeading="Sevenstore Stories"
            showHeading={false}
            storylyOptions={{
              classes: 'storyly-1 !mt-52'
            }}
          />

          {/* TITLE AND TEXT */}
          <TitleAndText
            data={componentData.titleAndText}
            showTitleText={true}
          />

          {/* APP BANNER - BLACK FRIDAY PREVIEW */}
          <Banner
            cta={'Black Friday Preview'}
            bfpDescription={'25% OFF'}
            bfpDescription2={'with code'}
            bfpDescription3={'BF25'}
            description2={'App Exclusive'}
            blackFridayPreview={true}
            DowloadCopy={'Download the Sevenstore App'}
          />

          {/* APP BANNER - BLACK FRIDAY */}
          <Banner
            cta={'black friday'}
            description={'Early access'}
            input={false}
            blackFriday={true}
            description2={'via the app'}
            percentage={'25% Off'}
          />

          {/* APP BANNER - 20% Discount */}
          <Banner
            cta={'20% off app exclusive'}
            description={'Use Code: APP20'}
            input={false}
            blackFriday={true}
          />

          {/* BLACK FRIDAY COMPONENTS */}
          <div className="flex flex-col gap-14 md:gap-28 pb-20 md:pb-32 mb-24 lg:mb-32 bg-blackFriday1">
            <Banner
              cta={'Black Friday'}
              bfpDescription={'25% OFF'}
              bfpDescription2={'with code'}
              bfpDescription3={'BF25'}
              blackFridayPreview={true}
              blackFriday24={true}
              buttonLink={'black-friday-offers/'}
              buttonLinkText={'Shop Now'}
              gaBlockTitle={'Black Friday Banner Button'}
              gaBlockName={'Black Friday Offers'}
              gaBlockId={'black-friday-banner-button'}
              cyberMonday24={false}
              cyberMonday24BGVid={
                isMobile
                  ? 'https://fa-ecom.s3.eu-west-2.amazonaws.com/images/sevenstore/black-friday/BlackFriday-Wave.avif'
                  : 'https://fa-ecom.s3.eu-west-2.amazonaws.com/images/sevenstore/black-friday/BlackFriday-Wave.avif'
              }
              cyberMonday24BGVidType={'video/webm'}
            />

            <CategoriesBrands
              data={componentData.bfCategories}
              gaBlockName={'Black Friday Categories'}
              categoryBrandOptions={{
                classes: 'categories-1'
              }}
              showCategoryBrand={true}
            />

            <CategoriesBrands
              data={componentData.bfBrands}
              gaBlockName={'Black Friday Brands'}
              categoryBrandOptions={{
                classes: 'brands-1'
              }}
              showCategoryBrand={true}
            />

            <NewArrivals
              gaBlockName={'Black Friday Carousel'}
              gaBlockNameClothing={'Black Friday Carousel Clothing'}
              gaBlockNameFootwear={'Black Friday Carousel Footwear'}
              gaBlockNameAccessories={'Black Friday Carousel Accessories'}
              newArrivalsHeading={'Black Friday Top Selects'}
              newArrivalsOptions={{
                classes: 'black-friday-top-selects-1 !my-0'
              }}
              blackFriday={true}
              blackFridayBadge={'25% Off'}
              isSeventhImage={true}
            />
          </div>

          {/* CYBER WEEK COMPONENTS */}
          <div className="flex flex-col gap-14 md:gap-28 pb-20 md:pb-32 mb-24 lg:mb-32 bg-blackFriday1">
            <Banner
              cta={'Cyber Week'}
              bfpDescription={'25% OFF'}
              bfpDescription2={'with code'}
              bfpDescription3={'BF25'}
              blackFridayPreview={true}
              blackFriday24={true}
              buttonLink={'black-friday-offers/'}
              buttonLinkText={'Shop Now'}
              gaBlockTitle={'Cyber Monday Banner Button'}
              gaBlockName={'Cyber Monday Offers'}
              gaBlockId={'cyber-monday-banner-button'}
              cyberMonday24={true}
              cyberMonday24BGVid={
                isMobile
                  ? 'https://fa-ecom.s3.eu-west-2.amazonaws.com/images/sevenstore/cyber-monday/CyberWeek-Mob-3.webm'
                  : 'https://fa-ecom.s3.eu-west-2.amazonaws.com/images/sevenstore/cyber-monday/CyberWeek-Desk-3.webm'
              }
              cyberMonday24BGVidType={'video/webm'}
            />

            <CategoriesBrands
              data={componentData.bfCategories}
              gaBlockName={'Cyber Week Categories'}
              categoryBrandOptions={{
                classes: 'categories-1'
              }}
              showCategoryBrand={true}
            />

            <CategoriesBrands
              data={componentData.bfBrands}
              gaBlockName={'Cyber Week Brands'}
              categoryBrandOptions={{
                classes: 'brands-1'
              }}
              showCategoryBrand={true}
            />

            <NewArrivals
              gaBlockName={'Cyber Week Carousel'}
              gaBlockNameClothing={'Cyber Week Carousel Clothing'}
              gaBlockNameFootwear={'Cyber Week Carousel Footwear'}
              gaBlockNameAccessories={'Cyber Week Carousel Accessories'}
              newArrivalsHeading={'Cyber Week Top Selects'}
              newArrivalsOptions={{
                classes: 'black-friday-top-selects-1 !my-0'
              }}
              blackFriday={true}
              blackFridayBadge={'25% Off'}
              isSeventhImage={true}
            />
          </div>
        </>
      )}

      {/* CURRENLY UNUSED COMPONETS */}
      {/* PROMO EVENT CUTOFF
        <PromoEventCutoff
          gaBlockName="Delivery Cut Offs Phase 2 - UK HP - DEC 2024"
          containerLink="/help-hub/#/delivery-uk"
          wrapperClass="mt-2 mb-4 mt-md-5 mb-md-5"
          bannerLink={true}
          fullWidth={false}
          cutoff={'Dec 23, 2024'}
          time={'15:00'}
          title={'Last Chance!'}
          subTitle={'Xmas Delivery'}
          subCopy={'Guaranteed Christmas Delivery'}
          subCopyTime={'3pm'}
          subCopy2={'Order Before 3pm Today'}
          subCopy3={'Select Guaranteed Christmas Delivery in the checkout'}
          showTimer={true}
          isGreen={false}
        />
      */}
    </section>
  );
};

export default App;
